/* tslint:disable */
/* eslint-disable */
/**
 * The Thing API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    SignatureBlock,
    SignatureBlockFromJSON,
    SignatureBlockFromJSONTyped,
    SignatureBlockToJSON,
} from './';

/**
 * 
 * @export
 * @interface BrandingOptions
 */
export interface BrandingOptions {
    /**
     * 
     * @type {SignatureBlock}
     * @memberof BrandingOptions
     */
    signatureBlock?: SignatureBlock;
}

export function BrandingOptionsFromJSON(json: any): BrandingOptions {
    return BrandingOptionsFromJSONTyped(json, false);
}

export function BrandingOptionsFromJSONTyped(json: any, ignoreDiscriminator: boolean): BrandingOptions {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'signatureBlock': !exists(json, 'signatureBlock') ? undefined : SignatureBlockFromJSON(json['signatureBlock']),
    };
}

export function BrandingOptionsToJSON(value?: BrandingOptions | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'signatureBlock': SignatureBlockToJSON(value.signatureBlock),
    };
}


